// extracted by mini-css-extract-plugin
module.exports = {"axis":"AxisY_axis__3kyq2","tick":"AxisY_tick__1ADPQ"};